import React, { useEffect, useState } from "react";
import ResumeHoc from "../../Components/Hoc/ResumeHoc";
import Input from "../../Components/Input/Input";
import Button from "../../Components/Button/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { savePersonalInfo, selectProfile } from "../../Redux/ResumeReducer/ResumeAction";
import { getCandidateProfileById, getUserById } from "../../Api/apiService";
import { ToastContainer, toast } from "react-toastify";
import { view_resume } from "../../Api/apiService";
import "./CreateResume.css";
import LayoutHOC from "../../Components/Hoc/ResumeHoc";
import ContainerWrapper from "../../Components/ContainerWrapper/container-wrapper";
import { Cpu, Sidebar } from "lucide-react";
import ResumeSidebar from "../../Components/Sidebar/Resume-Sidebar";
import { Col, Row } from "antd";
import CreateResumeWrapper from "./components/Create-Resume-Wrapper";
import InputWrapper from "../../Components/Input/Input-Wrapper";
import CustomInput from "../../Components/Input/Custom-Input";
import CustomizeButton from "../../Components/Button/Customize-Button";
import TextArea from "antd/es/input/TextArea";

function PersonalInfo() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const resume = useSelector((state) => state.resume);
  const selectedProfile = useSelector((state) => state.resume.selectedProfile);
 console.log(selectedProfile, "selected profile in personal info");
  console.log(resume, "this is resume");
  const profileId = new URLSearchParams(location.search).get("profileId");
  const candidateUserId = new URLSearchParams(location.search).get("candidateProfileId");
  console.log(candidateUserId, "Candidate Id");
  const user = JSON.parse(localStorage.getItem("auth")) || { name: "", email: "", userId: ""};
 console.log(user, "this is user from local storage");

  const curr_role =  user?.role;

  const userEmp = JSON.parse(localStorage.getItem("selectedEmployeeId")) || { userId: "" };

  const [resumeTitle, setResumeTitle] = useState("");

  const [firstName, setFirstName] = useState(resume.firstName || selectedProfile?.firstName || user.name.split(" ")[0] || "");
  const [lastName, setLastName] = useState(resume.lastName || selectedProfile?.lastName || user.name.split(" ")[1] || "");
  const [email, setEmail] = useState(resume.email || user.email || "");

  const [contactNo, setContactNo] = useState(resume.contactNo || "");
  const [objective, setObjective] = useState(resume.objective || selectedProfile?.objective || "");
  const [userDetails, setUserDetails] = useState();
  const [middleName, setMiddleName] = useState(resume.middleName || selectedProfile?.middleName || "");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userDet = useSelector((state) => state.auth);
  const { userId } = userDet;

  console.log(userId, "this is userId");
  console.log(user?.userId, "this is user id from local storage");
  const role = localStorage.getItem("selectedRole") || { selectedRole: "" };
  const candidateId = localStorage.getItem("profileId") || { profileId: "" };
  const selectedEmployeeId = localStorage.getItem("selectedEmployeeId") || selectedProfile?.userId || user?.userId|| { selectedEmployeeId: "" };



  const getCandidateDetails = async () => {
    console.log("");

    if (resume.firstName || resume.email || resume.contactNo) {
      console.log("Loading from Redux state");
      setFirstName(resume.firstName || "");
      setLastName(resume.lastName || "");
      setMiddleName(resume.middleName || "");
      setEmail(resume.email || "");
      
      setContactNo(resume.contactNo || "");
      setObjective(resume.objective || "");
      return;
    }

    try {
      const response = await getCandidateProfileById(candidateId);
      if (response?.status === 200 || response?.status === 201) {
        const profile = response.data;
        console.log(profile, "this is profile");

       setFirstName(profile?.firstName || "");
        setLastName(profile?.lastName || "");
        setMiddleName(profile?.middleName || "");
        setResumeTitle(profile?.resumeTitle);
        setEmail(profile?.email || "");
        setContactNo(profile?.contactNo || "");
        setObjective(profile?.objective || "");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const getUserDetails = async () => {
    console.log("API Called - getUserDetails", selectedEmployeeId);
    try {
      const response = await getUserById(selectedEmployeeId);
      console.log(response ,"this is the user Details ");

      if (response?.status === 200 || response?.status === 201) {
        setUserDetails(response.data);

        if (response.data?.email) setEmail(response.data?.email);

        const name = response.data?.name?.split(" ") || [];
        if (name?.length > 1) {
          setFirstName(name[0]);
          setLastName(name[1]);
        } else {
          setFirstName(name[0] || "");
          setLastName("");
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleNextClick = () => {
    console.log("we clicking on next");

    const profileName = `${firstName} ${lastName}`.trim();

    const updatedProfile = {
      ...resume,
      userId: userId,
      profileId: profileId || selectedProfile?.id,
      profileName: profileName,
      firstName: firstName,
      lastName: lastName,
      email: email,
      middleName:middleName,
      contactNo: contactNo,
      objective: objective,
    };

    console.log(updatedProfile, "this is updated Profile");

    // Save to resume state
    dispatch(savePersonalInfo(updatedProfile));

    if (selectedProfile) {
      dispatch(
        selectProfile({
          ...selectedProfile,
          profileName: profileName,
          email: email,
          contactNo: contactNo,
          objective: objective,
        })
      );
    }

    // Navigate based on whether we're editing or creating
    if (!profileId && !selectedProfile?.id) {
      navigate("/education");
    } else {
      navigate(`/education/?profileId=${profileId || selectedProfile.id}`);
    }
  };
  const handleNextClickEmployee = () => {

    //  const updatedProfile = {
    //   ...resume,

    //   firstName: firstName,
    //   lastName: lastName,
    //   email: email,
    //   middleName:middleName,
    //   contactNo: contactNo,
    //   objective: objective,
    // };

    // console.log(updatedProfile, "this is updated Profile");

    // // Save to resume state
    // dispatch(savePersonalInfo(updatedProfile));

    navigate("/education");
  };

  const handleNextClickCandidate = () => {

    console.log("we clicking on next");

    console.log(email, "this is email");
    console.log(contactNo, "this is contact no");

      console.log("Email type:", typeof email);
  console.log("Contact type:", typeof contactNo);
   if (email && email.trim() !== "") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email.trim())) {
      toast.warn("Please enter a valid email address with a proper domain", {
        autoClose: 3000,
      });
      return;
    }
  }

    const personalInfo = {
      userId: candidateId,
      profileId: candidateId,
      id: candidateId,
      firstName: firstName,
      lastName: lastName,
      middleName :middleName,
      email: email,
      contactNo: contactNo,
      objective: objective,
    };

    console.log("Saving candidate personal info:", personalInfo);
    dispatch(savePersonalInfo(personalInfo));

    navigate(`/education/?candidateProfileId=${candidateId}`);
  };
  useEffect(() => {
    if (role !== "candidate") {
      getUserDetails();
    } else {
      getCandidateDetails();
    }
  }, []);

  useEffect(() => {
    if (selectedProfile) {
      setContactNo(selectedProfile.contactNo || "");
      setObjective(selectedProfile.objective || "");
    }
  }, [selectedProfile]);

  const handleCancel = () => {
      navigate(user?.role === "ROLE_HR"  ? "/dashboardHr" : "/dashboard");
  }

  return (
    <ContainerWrapper breadcrumbItems={["Resume Builder", "Personal Info"]} userRole={user?.role}>
      <Row gutter={[20, 20]}>
        <Col span={6}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div>
              <ResumeSidebar title={resumeTitle || selectedProfile?.jobTitle || "Resume"} />
            </div>
          </div>
        </Col>
        <Col span={18}>
          <CreateResumeWrapper title={"Personal Information"}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                justifyContent: "space-between",
              }}
            >
              <Row
                style={{
                  borderRadius: "10px",
                  padding: "16px",
                  border: "1px solid #E8E8E8",
                  width:"100%"
                }}
              >
                <Row style={{ width: "100%" ,  display: "flex",
                      gap:"12px"
                    }}>
              
                    <div style={{
                      width:"33%"
                    }}>
                      <InputWrapper label={"First Name"} required>
                        <CustomInput
                        
                          value={firstName}
                          onChange={(e) => {
                            setFirstName(e.target.value);
                          }}
                          disabled={curr_role === "ROLE_EMPLOYEE"}
                         
                        ></CustomInput>
                      </InputWrapper>
                    </div>
                    <div style={{
                      width:"33%"
                    }}>
                      <InputWrapper label={"Middle Name"}>
                        <CustomInput value={middleName} onChange={(e) => setMiddleName(e.target.value)}  disabled={curr_role === "ROLE_EMPLOYEE"}  />
                      </InputWrapper>
                    </div>
                    <div style={{
                      width:"31.5%"
                    }}>
                      <InputWrapper label={"Last Name"} required>
                        <CustomInput
                          value={lastName}
                          onChange={(e) => {
                            setLastName(e.target.value);
                          }}
                           disabled={curr_role === "ROLE_EMPLOYEE"}
                       
                        ></CustomInput>
                      </InputWrapper>
                    </div>
                
                </Row>
                  <Row style={{
                      width:"100%",
                       display: "flex",
                    marginTop: "20px",
                    
                      gap: "12px",
                  }}>
                  
                    <div style={{
                      width:"100%",
                      display:"flex",
                      gap:"12px"
                    }}>
                      <InputWrapper style={{
                      width:"50%"
                    }} label={"Email"} required>
                        <CustomInput
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                          disabled={curr_role === "ROLE_EMPLOYEE"}
                      
                        ></CustomInput>
                      </InputWrapper>
               

                
                      <InputWrapper   style={{
                      width:"49%"
                    }}label={"Contact No."}  required>
                        <CustomInput
                          value={contactNo}
                          onChange={(e) => {
                            setContactNo(e.target.value);
                          }}
                       
                        ></CustomInput>
                      </InputWrapper>
                    </div>
                
                  </Row>
               
                <Row
                  style={{
                    width: "100%",
                    marginTop: "20px",
                  }}
                >
                  <InputWrapper className="bio-wrapper" label={"Bio"}>
                    <TextArea
                      value={objective}
                      onChange={(e) => {
                        setObjective(e.target.value);
                      }}
                      style={{
                        border: "1px solid #E8E8E8",
                        borderRadius: "10px",
                        width: "100%",
                        height: "20vh",
                        padding: "12px",
                        resize: "none",
                      }}
                      
                    />
                  </InputWrapper>
                </Row>
              </Row>

              <Row
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <CustomizeButton
                  onClick={role !== "candidate" ? (role === "employee" ? handleNextClickEmployee : handleNextClick) : handleNextClickCandidate}
                  variant="primary"
                  style={{ width: "14rem" }}
                >
                  {" "}
                  Save & Next{" "}
                </CustomizeButton>
                <CustomizeButton variant="outlined" style={{ width: "14rem" }} onClick={handleCancel}>
                  {" "}
                  Cancel
                </CustomizeButton>
              </Row>
            </div>
          </CreateResumeWrapper>
        </Col>
      </Row>
       <ToastContainer />
    </ContainerWrapper>
  );
}

export default LayoutHOC(PersonalInfo, { withSidebar: true });
